module.exports = __webpack_public_path__ + "img/trash-icon.3eb1bf5e.svg";